export default __webpack_public_path__ + "static/media/Sandbox_A01.3496b9e2.mp4";